import React from 'react';
import { Clock, ShieldCheck, Users, Ban } from 'lucide-react';
import { StripeWordmark } from './PaymentLogos';

const Badge = ({ tone = 'emerald', children }) => {
  const palette =
    tone === 'emerald'
      ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/35'
      : 'bg-gold-400/15 text-gold-300 border-gold-400/40';
  return (
    <span className={`px-2 py-0.5 rounded-md border text-[9.5px] font-black tracking-[0.12em] uppercase ${palette}`}>
      {children}
    </span>
  );
};

const DirectPaymentsSection = () => {
  return (
    <section
      className="relative bg-black pt-2 pb-10 lg:pb-14"
      data-testid="direct-payments-section"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-zinc-800 bg-gradient-to-br from-zinc-950 to-black px-5 py-5 lg:px-7 lg:py-6 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.6)]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-center">
            {/* Block 1 — headline */}
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-gold-500/10 border border-gold-500/30 flex items-center justify-center">
                <Clock className="w-5 h-5 text-gold-400" />
              </div>
              <div>
                <p className="text-[10.5px] uppercase tracking-[0.18em] text-gold-400 font-bold">
                  Secure &amp; trusted payments
                </p>
                <h3 className="mt-1.5 text-lg lg:text-xl font-extrabold text-white leading-tight">
                  Payments go directly to<br className="hidden lg:block" /> your own <span className="text-gold-400">Stripe account</span>.
                </h3>
              </div>
            </div>

            {/* Block 2 — Stripe */}
            <div className="flex items-center gap-4 lg:gap-5 md:border-l md:border-zinc-800/80 md:pl-6 lg:pl-8">
              <div className="flex items-center gap-2 flex-shrink-0">
                <StripeWordmark />
                <Badge tone="emerald">Active</Badge>
              </div>
              <p className="text-[12.5px] text-white/60 leading-snug">
                Restaurants get paid directly to their own Stripe accounts. NoFee never holds your money.
              </p>
            </div>

            {/* Block 3 — Security checklist */}
            <div className="flex items-start gap-3 md:border-l md:border-zinc-800/80 md:pl-6 lg:pl-8">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
                <ShieldCheck className="w-5 h-5 text-emerald-400" />
              </div>
              <ul className="text-[12.5px] text-white/75 space-y-1.5 leading-snug">
                <li className="flex items-center gap-1.5">
                  <span className="text-emerald-400">·</span> Secure payments
                </li>
                <li className="flex items-center gap-1.5">
                  <Users className="w-3.5 h-3.5 text-emerald-400/80" /> Trusted by thousands
                </li>
                <li className="flex items-center gap-1.5">
                  <Ban className="w-3.5 h-3.5 text-emerald-400/80" /> No fee holds or delays
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectPaymentsSection;
